// @ts-nocheck
import React from "react";
import ClearIcon from '@mui/icons-material/Clear';
import CheckIcon from '@mui/icons-material/Check';
import {styled} from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import makeStyles from '@mui/styles/makeStyles';
import DownloadIcon from '@mui/icons-material/Download';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SendIcon from '@mui/icons-material/Send';
import ScheduleSendIcon from '@mui/icons-material/ScheduleSend';
import Tooltip from '@mui/material/Tooltip';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import CloseIcon from '@mui/icons-material/Close';


const useStyles = makeStyles( theme =>({
    div: {
        marginLeft: '2%',
    }
}));

export function Cruz ({onClick}) {
    const classes = useStyles();

    const Cruz = styled(ClearIcon)(({theme})  => ({
        color: theme.palette.secondary.main,
        '&:hover': {
            color: theme.palette.secondary.dark,
        },
    }));

    return (
        <IconButton onClick={onClick} size="large">
            <div className={classes.div}>
                <Cruz/>
            </div>
        </IconButton>
    );
}

export function Check({ onClick}) {
    const classes = useStyles();

    const Check = styled(CheckIcon)(({theme})  => ({
        color: theme.palette.success.main,
        '&:hover': {
            color: theme.palette.success.dark,
        },
    }));

    return (
        <IconButton onClick={onClick} size="large">
            <div className={classes.div}>
                <Check/>
            </div>
        </IconButton>
    );
}

export function Send ({color , onClick}){
    const classes = useStyles();
    const Send= styled(SendIcon)(()  => ({
        color: color,
    }));

    return (
        <Tooltip title="Enviar">
        <IconButton onClick={onClick} size="large">
            <div className={classes.div}>
                <Send sx={{ fontSize: 40 }}/>
            </div>
        </IconButton>
        </Tooltip>
    );
}

export function ProgramationSend ({color , onClick}){
    const classes = useStyles();
    const ProgramationSend= styled(ScheduleSendIcon)(()  => ({
        color: color,
    }));

    return (
        <Tooltip title="Programar Envio">
        <IconButton onClick={onClick} size="large">
            <div className={classes.div}>
                <ProgramationSend sx={{ fontSize: 40 }}/>
            </div>
        </IconButton>
        </Tooltip>
    );
}

export function Download({color , onClick}) {
    const classes = useStyles();

    const Download = styled(DownloadIcon)(({theme})  => ({
        color: color,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    }));

    return (
        <IconButton onClick={onClick} size="large">
            <div className={classes.div}>
                <Download/>
            </div>
        </IconButton>
    );
}

export function Eye({color , onClick}) {
    const classes = useStyles();

    const Eye = styled(VisibilityIcon)(({theme})  => ({
        color: color,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    }));

    return (
        <IconButton onClick={onClick} size="large">
            <div className={classes.div}>
                <Eye/>
            </div>
        </IconButton>
    );
}

export function CheckAll({color , onClick}) {
    const classes = useStyles();
    
    const CheckAll = styled(DoneAllIcon)(({theme}) => ({
        color: color,
        '&:hover': {
            color: theme.palette.primary.main,
        },
    }));
    return (
        <Tooltip title="Marcar como leidas todas las noticias">
        <IconButton onClick={onClick} size="large">
            <div className={classes.div}>
                <CheckAll/>
            </div>
        </IconButton>
        </Tooltip>
    );
}

export function Done() {

    const CheckAll = styled(DoneAllIcon)(({theme}) => ({
        color: theme.palette.success.light
    }));
    return (
                    <CheckAll />
    )
}

export function CruzError() {

    const CruzError = styled(CloseIcon)(({theme}) => ({
        color: theme.palette.error.main
    }));
    return (
        <CruzError />
    )
}

